import { useEffect } from 'react';

import {
  GetReordersQueryParams,
  Reorder,
} from '../../../api/order/order.types';
import { ReorderType } from '../../../state/order/order.types';
import { Async, Status } from '../../../types/data.types';

interface UseReorderds {
  data: Reorder[];
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  showData: boolean;
}

export const useReorders = (
  loadReorderOrders: (
    queryParams: GetReordersQueryParams,
    reorderType: ReorderType,
    prId?: number,
  ) => void,
  reorderType: ReorderType,
  reordersParam: Async<Reorder[]> | { [prId: number]: Async<Reorder[]> },
  queryParams?: GetReordersQueryParams,
  isEnabled = false,
): UseReorderds => {
  const isRestaurantReorders =
    reorderType === 'restaurantCollectionReorders' ||
    reorderType === 'restaurantDeliveryReorders';

  const prId = queryParams?.storeIds?.length
    ? queryParams?.storeIds[0]
    : undefined;

  const reorders = isRestaurantReorders
    ? reordersParam[prId] || { status: Status.LOADING }
    : reordersParam;

  const isLoading = reorders.status === Status.LOADING && isEnabled;
  const isSuccess = reorders.status === Status.SUCCESS;
  const isError = reorders.status === Status.ERROR;
  const isEmpty = isSuccess && reorders.data.length === 0;

  useEffect(() => {
    if (!isRestaurantReorders && isEnabled) {
      if (reorderType === 'deliveryReorders' && queryParams?.storeIds?.length) {
        loadReorderOrders(queryParams, reorderType);
      } else if (reorderType === 'collectionReorders' && isLoading) {
        loadReorderOrders(queryParams, reorderType);
      }
    } else if (isRestaurantReorders && isLoading && prId) {
      loadReorderOrders(queryParams, reorderType, prId);
    }
  }, [isLoading, queryParams?.fulfilmentType, queryParams?.storeIds?.length]);

  const reordersData = isSuccess ? reorders.data : [];

  const showData = isLoading || (!isError && !isEmpty && isEnabled);

  return {
    data: reordersData,
    isError,
    isLoading,
    isSuccess,
    showData,
  };
};
